import db from "@/common/function/indexedDb";

export default {
  state: {
    table_base_data: [],
    table_config: [],
    table_customer: [],
    table_customer_level: [],
    table_client_level: [],
    table_customer_glass_level: [],
    table_customer_door_level: [],
    table_product: [],
    table_product_category: [],
    table_product_option: [],
    table_product_price: [],
    table_product_door_price: [],
    table_product_door_color_price: [],
    table_sale_type: [],
    table_product_type: [],
    table_unit: [],
    table_user: [],
    table_user_authority: [],
    table_user_group: [],
    table_account: [],
    table_asset_category: [],
    table_glass_color: [],
    table_glass_thickness: [],
    table_product_glass_price: [],
    table_option: [],
    table_branch: [],
    table_notice: [],
    table_door_color: [],
    temp_data: {}, //임시 저장용
  },
  getters: {
    table_base_data(state) {
      return state.table_base_data;
    },
    table_config(state) {
      return state.table_config;
    },
    table_customer(state) {
      return state.table_customer;
    },
    table_customer_level(state) {
      return state.table_customer_level;
    },
    table_client_level(state) {
      return state.table_client_level;
    },
    table_customer_glass_level(state) {
      return state.table_customer_glass_level;
    },
    table_customer_door_level(state) {
      return state.table_customer_door_level;
    },
    table_product(state) {
      return state.table_product;
    },
    table_product_category(state) {
      return state.table_product_category;
    },
    table_product_option(state) {
      return state.table_product_option;
    },
    table_product_price(state) {
      return state.table_product_price;
    },
    table_product_door_price(state) {
      return state.table_product_door_price;
    },
    table_product_door_color_price(state) {
      return state.table_product_door_color_price;
    },
    table_sale_type(state) {
      return state.table_sale_type;
    },
    table_product_type(state) {
      return state.table_product_type;
    },
    table_unit(state) {
      return state.table_unit;
    },
    table_user(state) {
      return state.table_user;
    },
    table_user_authority(state) {
      return state.table_user_authority;
    },
    table_user_group(state) {
      return state.table_user_group;
    },
    table_account(state) {
      return state.table_account;
    },
    table_asset_category(state) {
      return state.table_asset_category;
    },
    table_glass_color(state) {
      return state.table_glass_color;
    },
    table_glass_thickness(state) {
      return state.table_glass_thickness;
    },
    table_product_glass_price(state) {
      return state.table_product_glass_price;
    },
    table_option(state) {
      return state.table_option;
    },
    table_branch(state) {
      return state.table_branch;
    },
    table_notice(state) {
      return state.table_notice;
    },
    temp_data(state) {
      return state.temp_data;
    },
    table_door_color(state) {
      return state.table_door_color;
    },
    tables(state) {
      return Object.keys(state).filter((s) => s.startsWith("table_"));
    },
  },
  actions: {
    async checkTable(context, tables) {
      await db.checkTable(tables);
    },
    async getsLocalDb(context, table) {
      context.state[table] = [];
      let items = await db.gets(table);
      items.forEach((c) => {
        context.state[table].push(c);
      });
      return context.state[table];
    },
    async registerLocalDb(context, arg) {
      db.clear(arg.table);
      db.register(arg.table, arg.data);
    },
    async saveLocalDb(context, arg) {
      const index = context.state[arg.table].findIndex(
        (i) => i.id === arg.data.id
      );
      //while passing with action, data return to observer. so it need to cast like below.
      const data = JSON.parse(JSON.stringify(arg.data));
      if (index > -1) {
        context.state[arg.table].splice(index, 1, data);
      } else {
        context.state[arg.table].push(data);
      }
      await db.save(arg.table, arg.data);
    },
    async deleteLocalDb(context, arg) {
      // arg.data = data가 아니라 id 이다.
      const index = context.state[arg.table].findIndex(
        (i) => i.id === arg.data
      );
      if (index > -1) {
        context.state[arg.table].splice(index, 1);
      }
      await db.delete(arg.table, arg.data);
    },
  },
};
